<template>
  <div id="app">
    <div class="test-env" v-if="is_test">staging-0914</div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- Cookie Consent（仅海外构建、非 embed、且本浏览器没选过时展示） -->
    <CookieConsent @accepted="onCookieConsentAccepted" />
  </div>
</template>

<script>
import { defaultTitle } from '@/config'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getToken } from '@/utils/cache'
import { notNeedSignupRoutes, isRouteMatch } from '@/router/adapter'
//minxpanel
import { analyticsInit } from '@/utils/AnalyticsCenter'
import analytics from '@/utils/AnalyticsCenter'
import packageInfo from '@/../package.json'
import { getPublicUrl } from '@/serves/api/publicUrl'
import { IS_CHINA } from '@/config'
import { mixinMixpanel } from '@/mixins'
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  name: 'App',
  components: { CookieConsent },
  mixins: [mixinMixpanel],
  data() {
    return {
      is_test: false,
    }
  },
  computed: {
    ...mapState({
      missingPart: (state) => state.user.missing_part,
      isLogin: (state) => state.user.login,
    }),
    isChina() {
      return IS_CHINA
    },
  },
  watch: {
    $route: {
      // 动态标题
      handler: function (route) {
        let title = ''
        for (let index = route.matched.length - 1; index >= 0; index--) {
          const t = route.matched?.[index]?.meta?.title
          if (t) {
            title = t
            break
          }
        }
        // document.title = title || defaultTitle

        // 路由切换时
        this.checkMissingPart(this.missingPart)
      },
      immediate: true,
    },
    // 页面刷新加载时
    missingPart: {
      handler: function (part) {
        this.checkMissingPart(part)
      },
      immediate: true,
    },
    isLogin: {
      handler() {
        this.refreshLevelList()
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 初始化埋点并注册通用参数。
     * 海外构建在用户未同意 Cookie 时，analyticsInit 内部会直接返回
     * （registry 为空，registerCommonParams / logEvent 全部安全空转）；
     * 用户点 Accept 后由 onCookieConsentAccepted 再调一次，当场生效、不用刷新。
     */
    setupAnalytics() {
      analyticsInit()
      const version = packageInfo.version
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        local = 'Chinese'
      } else if (local == 'en') {
        local = 'English'
      }
      analytics.registerCommonParams({
        hskmock_language: local,
        hskmock_version: version,
        logged_in: this.$store.state.user.login,
        people_id: this.peopleId,
        unlimited: this.unlimited,
        auth0_id: this.$store.state.user.userId,
      })
    },
    onCookieConsentAccepted() {
      this.setupAnalytics()
      // 登录用户在本次会话里才点的 Accept：登录时 refreshUser 的
      // identify / setUserProperties 发生在 Mixpanel 还没初始化的时候
      //（被闸门空转掉了），这里按 store 里的值补上，字段与
      // store/modules/user.js 的 refreshUser 保持一致
      const user = this.$store.state.user
      if (user.userId) {
        analytics.identify(user.userId)
        analytics.setUserProperties({
          email: user.email,
          people_id: user.person_id,
          auth0_id: user.userId,
        })
      }
    },
    ...mapActions({
      refreshUser: 'user/refreshUser',
      refreshGrade: 'grade/refreshGrade',
      refreshLevelList: 'level/refreshLevelList',
      checkIsFreeTest: 'user/checkIsFreeTest',
    }),
    ...mapMutations({
      SET_PUBLIC_URL: 'publicUrl/SET_PUBLIC_URL',
    }),
    // 校验用户注册流程missingPart
    checkMissingPart(missingPart) {
      if (missingPart) {
        const needProfile = !isRouteMatch(notNeedSignupRoutes, this.$route.fullPath)
        if (missingPart && needProfile) {
          this.$router.push(`/profile/${missingPart}`)
        }
      }
    },
    //获取公共资源请求地址
    getPublicUrl() {
      getPublicUrl().then((res) => {
        this.SET_PUBLIC_URL({ mockPublicUrl: res.data.pub_url })
      })
    },
  },
  created() {
    if (process.env.VUE_APP_MODE !== 'prod') {
      this.is_test = true
    }
    this.setupAnalytics()

    let token = getToken()
    if (token) {
      this.refreshGrade()
      this.refreshUser()
      this.checkIsFreeTest()
    }
    // if (this.isChina) {
    this.getPublicUrl()
    // }
  },
}
</script>

<style lang="scss">
.test-env {
  position: absolute;
  top: 100px;
  left: 20px;
  font-size: 30px;
  color: red;
  z-index: 5000;
}
.submenu-content {
  margin-top: 13px !important;
  .el-menu--popup-bottom-start {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
.layui-layer-dialog .layui-layer-content {
  word-break: break-word;
}
.tab-dropdown {
  width: 100%;
  margin-left: -5px !important;
  margin-top: 11px !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  background-color: #1c1f33 !important;
  border: none !important;
  .popper__arrow {
    display: none !important;
  }
  .el-dropdown-menu__item {
    color: #fff !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    &:not(:nth-of-type(4)) {
      border-bottom: 1px solid #565a76;
    }
  }
}
.level-dropdown {
  margin: 0 !important;
  padding: 0 !important;
  .el-dropdown-menu__item {
    width: 138px;
    padding: 0;
    &:not(:last-of-type) {
      border-bottom: 2px solid #efeff1;
    }
    .el-collapse-item__header {
      position: relative;
      justify-content: center;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      border-bottom: none;
      .el-collapse-item__arrow {
        margin: 0 !important;
      }

      .title-content {
        width: 100%;
      }
      .el-collapse-item__arrow {
        position: absolute;
        right: 37px;
      }
    }
    .el-collapse {
      border: none;
      .el-collapse-item__wrap {
        border-bottom: none !important;
      }
      .el-collapse-item__content {
        padding: 0 !important;
      }
    }
    .level-test {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }
  // .el-collapse {
  //   border-bottom: none;
  //   &:not(:first-of-type) {
  //     border-top: 1px solid #efeff1;
  //   }
  // }
}
.assignmentPopper {
  background: #2c2f46 !important;
  opacity: 0.9 !important;
  color: #e7e7ed !important;
  min-height: 50px !important;
  .popper__arrow {
    &::after {
      border-top-color: #2c2f46 !important;
    }
  }
}
</style>
